import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './GooglePlacesWidget.html?raw';
import { Loader } from '@googlemaps/js-api-loader';
import { AddressWizardTypes } from "../../../WidgetCollection/AddressWizard/AddressWizardTypes";
import { Schluesseldienst } from "../../Tools/Schluesseldienst"
import { AccessibilityLabelsHelper } from "../../../more/Helpers";


class GooglePlacesWidget extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private addressEntity: AddressWizardTypes.AddressEntity;
    private loader: Loader;

    private autocomplete: HTMLInputElement;
    private labelNode: HTMLInputElement;
    private placeAutocompleteCard: HTMLElement;
    private mapContainer: HTMLElement;
    private placeDetailsContainer: HTMLElement;
    private orgAddressDetailsContainer: HTMLElement;

    private currentPlace: google.maps.places.PlaceResult = null;
    private center: any = { lat: 48.210033, lng: 16.363449 }; //Wien
    private map: google.maps.Map;
    private marker: google.maps.marker.AdvancedMarkerElement;
    private infoWindow: google.maps.InfoWindow;
    private placeAutocomplete: google.maps.places.Autocomplete;
    private service: google.maps.places.PlacesService;

    constructor(addressEntity?: AddressWizardTypes.AddressEntity) {
        super(...(arguments as unknown as []));
        this.addressEntity = addressEntity;
    }

    getCurrentPlaceData(): Array<{ key: string, value: any }> {
        let arr = [];
        let street_data = { key: "street", value: "" };

        for (let p in this.currentPlace) {
            let value = null;

            switch (p) {
                case "address_components":
                    this.currentPlace[p].forEach(comp => {
                        comp.types.forEach(type => {
                            switch (type) {
                                case "locality":
                                case "country":
                                case "postal_code":
                                    value = { key: type, value: comp.long_name }
                                    arr.push(value);
                                    break;
                                case "route":
                                    street_data.value = `${comp.long_name}${street_data.value}`
                                    break;
                                case "street_number":
                                    street_data.value = `${street_data.value} ${comp.long_name}`
                                    break;
                            }
                        })
                    })
                    break;
                case "name":
                    value = { key: p, value: this.currentPlace[p] }
                    arr.unshift(value);
                    break;
                case "international_phone_number":
                case "website":
                    value = { key: p, value: this.currentPlace[p] }
                    arr.push(value);
                    break;
            }
        }

        if (street_data.value) arr.splice(1, 0, street_data);
        return arr;
    }

    private getInitialLocation() {
        window.navigator.geolocation.getCurrentPosition(
            lang.hitch(this, this.onGeoLoc_Success),
            lang.hitch(this, this.onGeoLoc_Error));
    }

    private async initMap() {

        await this.loader
            .load()
            .then(async (google) => {
                await Promise.all([
                    google.maps.importLibrary("marker"),
                    google.maps.importLibrary("places")
                ])
                    .then(() => {
                        this.continueInitMap();
                    })
                    .catch(e => {
                        console.error(e);
                    });
            });
    }
    private continueInitMap() {
        
        this.map = new google.maps.Map(this.mapContainer, {
            center: this.center,
            zoom: 13,
            mapTypeControl: false,
            mapId: "GOOGLE_MAP_WIDGET"
        });

        if (this.addressEntity) {            
            this.service = new google.maps.places.PlacesService(this.map);
            this.service.textSearch({
                query: `${this.addressEntity.name}, ${this.addressEntity.street} ${this.addressEntity.c_postal_code} ${this.addressEntity.c_city}, ${this.addressEntity.ref_country?.description}`,
                language: window.currentLanguageCode2
            }, (response) => {
                this.autocomplete.value = response[0].name;
                this.updateCurrentPlace(response[0], true);
            });

            this.hideNode(this.orgAddressDetailsContainer, false);

            this.UiModder.domConstruct.create("h4", { innerHTML: `${this.translate("GooglePlacesWidget_Label_SourceAddress")}`, class: "bold" }, this.orgAddressDetailsContainer);
            this.UiModder.domConstruct.create("h5", { innerHTML: `${this.addressEntity.name}`, class: "bold italic w3-text-gray" }, this.orgAddressDetailsContainer);

            let placeDetails = `${this.addressEntity.street}, ${this.addressEntity.c_postal_code} ${this.addressEntity.c_city}`;
            if (this.addressEntity.ref_country) placeDetails = `${placeDetails}, ${this.addressEntity.ref_country.description}`;

            this.UiModder.domConstruct.create("div", { innerHTML: placeDetails, class: "w3-text-gray" }, this.orgAddressDetailsContainer);
        }

        this.placeAutocomplete = new google.maps.places.Autocomplete(this.autocomplete);

        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.placeAutocompleteCard);
        this.UiModder.domClass.remove(this.placeAutocompleteCard, "w3-hide");

        this.placeAutocomplete.addListener("place_changed", lang.hitch(this, this.updateCurrentPlace));
        
        // Create the marker and infowindow.
        this.marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map
        });

        this.infoWindow = new google.maps.InfoWindow({});

        setTimeout(() => { this.StandbyStop() }, 2500);
    }

    private updateMarker() {

        this.map.setCenter(this.center);
        this.marker.position = this.currentPlace.geometry.location;
    }

    private updateInfoWindow() {

        this.infoWindow.setContent(this.currentPlace.formatted_address);
        this.infoWindow.setHeaderContent(this.currentPlace.name);
        
        this.infoWindow.open({
            map: this.map,
            anchor: this.marker,
            shouldFocus: false, 
        });            
    }

    private updateCurrentPlace(place?: google.maps.places.PlaceResult, init:boolean = false) {
        if (!place) place = this.placeAutocomplete.getPlace();

        this.currentPlace = place;

        if (init === false) {
            this.emit("place_changed");
            this.hideNode(this.placeDetailsContainer, false);
        };
                
        this.center = this.currentPlace.geometry.location.toJSON();
        this.updateMarker();
        //this.updateInfoWindow();

        this.createPlaceSummary();
    }

    private createPlaceSummary() {
        this.UiModder.domConstruct.empty(this.placeDetailsContainer);

        var icon_place = this.createFontawesomeIcon("fas fa-map-marker-alt w3-text-blue paddingSmall");
        var icon_globe = this.createFontawesomeIcon("fas fa-globe w3-text-blue paddingSmall");
        var icon_phone = this.createFontawesomeIcon("fas fa-phone w3-text-blue paddingSmall");

        this.UiModder.domConstruct.create("h4", { innerHTML: `${this.translate("GooglePlacesWidget_Label_FoundAddress")}`, class: "bold" }, this.placeDetailsContainer);
        this.UiModder.domConstruct.create("h5", { innerHTML: `${this.currentPlace.name}`, class: "bold italic" }, this.placeDetailsContainer);

        if (this.currentPlace.formatted_address) {
            let div = this.UiModder.domConstruct.create("div", { class: "flex_row" }, this.placeDetailsContainer);
            let content = this.UiModder.domConstruct.create("div", { innerHTML: `${this.currentPlace.formatted_address}`, class: " paddingSmall" }, div);
            this.UiModder.domConstruct.place(icon_place, content, "first");
        }
        if (this.currentPlace.website) {
            let div = this.UiModder.domConstruct.create("div", { class: "flex_row" }, this.placeDetailsContainer);
            let content = this.UiModder.domConstruct.create("div", { innerHTML: `${this.currentPlace.website}`, class: " paddingSmall" }, div);
            this.UiModder.domConstruct.place(icon_globe, content, "first");
        }
        if (this.currentPlace.international_phone_number) {
            let div = this.UiModder.domConstruct.create("div", { class: "flex_row" }, this.placeDetailsContainer);
            let content = this.UiModder.domConstruct.create("div", { innerHTML: `${this.currentPlace.international_phone_number}`, class: " paddingSmall" }, div);
            this.UiModder.domConstruct.place(icon_phone, content, "first");
        }
    }

    private onGeoLoc_Success(localization: GeolocationPosition) {

        this.center.lat = localization.coords.latitude;
        this.center.lng = localization.coords.longitude;
        this.initMap();
    }
    private onGeoLoc_Error(error: GeolocationPositionError) {

        console.warn("GeolocationPositionError: ", error.message);
        this.initMap();
    }

    private setupNewLoader(apiKey: string) {

        this.loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
            libraries: ["marker", "places"],
            language: window.currentLanguageCode2
        })

        this.getInitialLocation();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.StandbyStart();

        Schluesseldienst.fetchKeyAsync(this.RequestManager, "PASS_GooglePlacesWidget_ApiKey").then((value: string) => {
            this.setupNewLoader(value); 
        });

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.autocomplete, "autocomplete", this.labelNode, false, false);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(GooglePlacesWidget);